import { render, staticRenderFns } from "./qianbao02_list.vue?vue&type=template&id=3a25be90&scoped=true"
import script from "./qianbao02_list.vue?vue&type=script&lang=js"
export * from "./qianbao02_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a25be90",
  null
  
)

export default component.exports